import {
  PublicClientApplication,
  type Configuration,
  type SilentRequest,
  LogLevel,
} from "@azure/msal-browser";

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string | undefined;
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID as string | undefined;

if (import.meta.env.PROD && (!clientId || !tenantId)) {
  throw new Error(
    "VITE_ENTRA_CLIENT_ID and VITE_ENTRA_TENANT_ID must be set in production"
  );
}

const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? "",
    authority: `https://login.microsoftonline.com/${tenantId ?? "common"}`,
    redirectUri: (import.meta.env.VITE_REDIRECT_URI as string | undefined) ?? window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level === LogLevel.Error) {
          console.error("[MSAL]", message);
        }
      },
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};

export const API_SCOPES = [
  `api://${clientId ?? ""}/access_as_user`,
];

export async function getAccessToken(): Promise<string | null> {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    return null;
  }

  const silentRequest: SilentRequest = {
    scopes: API_SCOPES,
    account: accounts[0],
  };

  try {
    const response = await msalInstance.acquireTokenSilent(silentRequest);
    return response.accessToken;
  } catch {
    // Silent token acquisition failed — redirect to login
    await msalInstance.acquireTokenRedirect(silentRequest);
    return null;
  }
}
